var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{style:(_vm.getValiMandaVisualizer().style),attrs:{"aria-hidden":"true","scale":_vm.scale,"name":_vm.getValiMandaVisualizer().icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }